import { Sanity$StructuredData } from '@otovo/shared/types/sanityTypes';
import Head from 'next/head';

type Props = {
  structuredData?: Sanity$StructuredData[];
};

const StructuredDataScripts = ({ structuredData }: Props) => {
  if (!structuredData?.length) {
    return null;
  }

  return (
    <Head>
      {structuredData.map((block) => (
        <script
          key={block._key}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: block.jsonLd?.code || '' }}
        />
      ))}
    </Head>
  );
};

export default StructuredDataScripts;
